class ComponentProductBar extends Theme.Component {
  #submitting = false;

  connectedCallback() {
    this.defineElements({
      form: "form"
    });

    this.addEvent("submit", this.elements.form, this.onSubmit);
    this.addEvent("product:variantchange", document, this.onVariantChange);

    this.observeProductSection();
    this.events();
  }

  observeProductSection() {
    const section = document.querySelector(".theme-sections > section:first-child");

    const observer = new IntersectionObserver((entries) => {
      this.classList.toggle("active--true", !entries[0].isIntersecting);
    }, { rootMargin: "50px 0px 0px 0px" });

    observer.observe(section);
  }

  onSubmit(event) {
    event.preventDefault();

    if (this.#submitting) {
      return;
    }

    this.#submitting = true;

    const data = new FormData(this.elements.form);

    fetch("/cart/add.js", {
      method: "POST",
      body: data
    })
    .then(response => {
      return response.json();
    })
    .then(response => {
      document.dispatchEvent(new CustomEvent("addtocart", {
        detail: response
      }));
    })
    .catch(error => {
      console.error("ProductFormSubmitError: ", error);
    })
    .finally(() => {
      this.#submitting = false;
    });
  }

  onVariantChange(event) {
    this.render({ variant: event.detail.variant_id });
  }

  render(params = {}) {
    const url = new URL(location.pathname, location.origin);

    url.searchParams.set("section_id", this.id);

    for (const [param, value] of Object.entries(params)) {
      url.searchParams.set(param, value);
    }

    fetch(url.href)
      .then(response => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fragment = doc.getElementById(this.id);

        this.replaceWith(fragment);
      });
  }
}

customElements.define("component-product-bar", ComponentProductBar);
